import { t } from '@/features/i18n/utils';
import { BidBreadcrumbs } from '@/features/bids/components/bid-breadcrumbs';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { HeaderBackButton, HeaderChatButton, Header } from '@/ui/components/header';
import { MainHeader, MainHeaderBackButton, MainScrollArea } from '@/ui/components/main';
import { H1 } from '@/ui/components/heading';
import { FilesPageList } from '@/features/documents/components/files-page/files-page-list';
import {
  FilesPageAddFilesButton,
  FilesPageCount,
} from '@/features/documents/components/files-page/files-page-header';
import { FileUploadDialog } from '@/features/documents/components/file-upload';
import { IndexingStatusAlerts } from '@/features/documents/components/indexing-status-alerts';
import { entityDocumentsQuery } from '@/features/documents/queries';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/bids/$bidId/_layout/files/',
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient.query({
      ...entityDocumentsQuery(params.bidId, 'bid'),
      staleTime: 'static',
    }),
});

function RouteComponent() {
  const navigate = useNavigate();
  const { bidId, projectId, workspaceId } = Route.useParams();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <BidBreadcrumbs>
          <BreadcrumbPage>{t({ en: 'Files', nb: 'Filer' })}</BreadcrumbPage>
        </BidBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <IndexingStatusAlerts resourceId={bidId} documentType="bid" />
        <MainHeader>
          <H1>
            <MainHeaderBackButton
              to="/project/$projectId/workspaces/$workspaceId/bids/$bidId"
              params={{ projectId, workspaceId, bidId }}
            />
            {t({ en: 'Files', nb: 'Filer' })}
            <FilesPageCount resourceId={bidId} resourceType="bid" />
          </H1>
          <FilesPageAddFilesButton resourceId={bidId} resourceType="bid" />
        </MainHeader>
        <FilesPageList
          resourceId={bidId}
          resourceType="bid"
          onRowClick={(doc) => {
            navigate({
              to: '/project/$projectId/workspaces/$workspaceId/bids/$bidId/files/$documentId',
              params: { projectId, workspaceId, bidId, documentId: doc.id },
            });
          }}
        />
      </MainScrollArea>
      <FileUploadDialog resourceId={bidId} resourceType="bid" />
    </>
  );
}
